module.exports = __webpack_public_path__ + "static/media/logo.00bccb90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.svg
// module id = 74
// module chunks = 0